import { Resizable } from "re-resizable";
import { Dispatch, PropsWithChildren, SetStateAction } from "react";
import styles from "./ResizablePagePanel.module.scss";

const enableArray = [
    "top",
    "right",
    "bottom",
    "left",
    "topRight",
    "bottomRight",
    "bottomLeft",
    "topLeft",
];

interface ResizablePanelProps {
    width: number;
    setWidth: Dispatch<SetStateAction<number>>;
    minWidth: number;
    maxWidth: number;
    enableHandlers: { [K in (typeof enableArray)[number]]?: true };
}

export const ResizablePagePanel = ({
    width,
    setWidth,
    minWidth,
    maxWidth,
    enableHandlers,
    children,
}: PropsWithChildren<ResizablePanelProps>) => {
    const enable = enableArray.reduce((acc, handler) => {
        if (enableHandlers[handler]) {
            acc[handler] = true;
        } else {
            acc[handler] = false;
        }
        return acc;
    }, {});

    return (
        <Resizable
            defaultSize={{
                width,
                height: "auto",
            }}
            minWidth={minWidth}
            maxWidth={maxWidth}
            handleClasses={{
                right: `${styles.pageResizeHandle} ${styles.rightPageResizeHandle}`,
                left: `${styles.pageResizeHandle} ${styles.leftPageResizeHandle}`,
            }}
            enable={enable}
            onResize={(e: any, direction: any, ref: any, d: any) => {
                setWidth((prevWidth: number) => {
                    const newWidth = ref.offsetWidth;
                    if (newWidth >= minWidth && newWidth <= maxWidth) {
                        return newWidth;
                    }
                    return prevWidth;
                });
            }}
        >
            {children}
        </Resizable>
    );
};
